import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function Search() {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    if (!query) {
      setUsers([]);
      return;
    }
    const run = async () => {
      setLoading(true);
      try {
        const response = await api.get('/searchUsers', { params: { query } });
        setUsers(response.data || []);
      } catch (err) {
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };
    const id = setTimeout(run, 300);
    return () => clearTimeout(id);
  }, [query]);

  return (
    <div className="list">
      <div className="card">
        <h2 className="section-title">{t('search.title')}</h2>
        <p className="section-subtitle">{t('search.subtitle')}</p>
        <input
          className="input"
          placeholder={t('search.placeholder')}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{ marginTop: 16 }}
        />
      </div>

      <div className="grid two-col">
        {(loading ? [] : users).map((item) => {
          const avatar = resolveMediaUrl(item.userImage);
          return (
            <div
              key={item._id}
              className="card"
              role="button"
              tabIndex={0}
              onClick={() => {
                if (item._id === user?.id) {
                  navigate('/profil');
                } else {
                  navigate(`/kullanici/${item._id}`);
                }
              }}
            >
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div className="brand-mark" style={{ background: 'linear-gradient(135deg,#38bdf8,#22d3ee)' }}>
                  {item.nickName?.slice(0, 1)?.toUpperCase() || 'A'}
                </div>
                {avatar ? (
                  <img src={avatar} alt={item.nickName} style={{ width: 54, height: 54, borderRadius: 18 }} />
                ) : null}
                <div>
                  <div style={{ fontWeight: 700 }}>{item.name} {item.surname || ''}</div>
                  <div className="muted">@{item.nickName}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {!loading && query && users.length === 0 ? (
        <div className="card">
          <p className="muted">{t('search.empty')}</p>
        </div>
      ) : null}
    </div>
  );
}
